export default "__VITE_ASSET__DNjtY5K9__"